const HERO_IMG =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_cameron-portfolio/artifacts/c84924974da6a5b9_Screenshot%202026-11-02%20at%201.49.24%E2%80%AFPM.png";

const HERO_LOCKUP =
  "https://customer-assets.emergentagent.com/job_cameron-portfolio/artifacts/l5a8iz3a_Mr_Possible_ABF_Home.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen overflow-hidden bg-black"
    >
      {/* DESKTOP — portrait right, lockup left */}
      <div className="hidden md:block">
        <img
          src={HERO_IMG}
          alt="Cameron Bergsma"
          draggable={false}
          data-testid="hero-portrait"
          className="absolute bottom-0 right-6 lg:right-12 h-[78vh] max-h-[720px] w-auto object-contain object-bottom select-none pointer-events-none"
          style={{
            maskImage:
              "linear-gradient(to right, transparent 0%, black 14%, black 100%)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent 0%, black 14%, black 100%)",
          }}
        />
        <div className="relative z-10 mx-auto max-w-[1440px] w-full px-12 min-h-screen flex flex-col justify-center">
          <img
            src={HERO_LOCKUP}
            alt="mr. possible — the one and only"
            data-testid="hero-lockup"
            className="w-[55%] lg:w-[50%] h-auto select-none"
            draggable={false}
          />
        </div>
      </div>

      {/* MOBILE — stacked: portrait top, lockup bottom */}
      <div className="md:hidden flex flex-col min-h-screen pt-20">
        <div className="w-full h-[58vh] flex items-center justify-center bg-black">
          <img
            src={HERO_IMG}
            alt="Cameron Bergsma"
            draggable={false}
            className="max-h-full w-auto object-contain select-none pointer-events-none"
          />
        </div>
        <div className="flex-1 flex items-center justify-center px-6 pb-10 pt-4">
          <img
            src={HERO_LOCKUP}
            alt="mr. possible — the one and only"
            data-testid="hero-lockup-mobile"
            className="w-full max-w-[420px] h-auto select-none"
            draggable={false}
          />
        </div>
      </div>
    </section>
  );
}
